import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
	ManpowerVehiclesApiService,
	ListVehiclesResponse,
} from '../../../services/manpowerVehiclesApi';

/**
 * List active vehicles for a single vendor (the list endpoint is per-vendor).
 * Only runs once a vendor is selected — `enabled` is false while vendorId is undefined.
 */
export const useVehicleData = (vendorId?: number): UseQueryResult<ListVehiclesResponse, Error> => {
	return useQuery({
		queryKey: ['manpower', 'vehicles', 'listing', vendorId],
		queryFn: async (): Promise<ListVehiclesResponse> => {
			return ManpowerVehiclesApiService.listVehicles(vendorId as number);
		},
		enabled: vendorId != null,
		staleTime: 0,
		gcTime: 0,
		refetchOnMount: true,
		refetchOnWindowFocus: false,
		retry: 1,
	});
};
